// extracted by mini-css-extract-plugin
module.exports = {"loadingHUDBackground":"LoadingHUD_loadingHUDBackground__2AmpL","loadingHUDModal":"LoadingHUD_loadingHUDModal__2-JMw","loadingHUDModalText":"LoadingHUD_loadingHUDModalText__2VrxL"};